import type { ProjectState } from "hooks/useProjects/useProjects.types";

export type ProjectApiKeyAccessBlockedReason =
  | "project_license_required"
  | "studio_license_required"
  | "subscription_required";

export type ProjectApiKeyAccess = {
  allowed: boolean;
  blockedReason: ProjectApiKeyAccessBlockedReason | null;
  message: string | null;
};

export function isWriterOtpLicensedProject(
  project: Pick<ProjectState, "otpSeating" | "isLicensed"> | null | undefined
): boolean {
  if (project?.isLicensed === false) {
    return false;
  }
  return project?.otpSeating?.licenseTier === "writer";
}
